import React from 'react';
import RadioGroupField from 'components/RadioGroupField';
import useOptions from '../../hooks/useOptions';

import './BusinessPerformanceField.styles.scss';
import './BusinessPerformanceField.styles.responsive.scss';

const BusinessPerformanceField: React.FC = () => {
  const { businessPerformanceOptions } = useOptions();

  return (
    <div className="business-performance-field">
      <RadioGroupField
        name="businessPerformance"
        options={businessPerformanceOptions}
        styled
      />
    </div>
  );
};

export default BusinessPerformanceField;
